import React from 'react'
import SupportHero from '../components/SupportHero'
import ArticlesList from '../components/ArticlesList'
import Banner from '../components/Banner'
import Categories from '../components/Categories'
import '../style.css'

function SupportPage(props) {
  return (
    <>
      <div
        className={`${
          props.dark ? 'bg-gradient-support text-white' : 'bg-white text-black'
        } bg-gradient-to-r pt-16`}
      >
        {props.categories && props.categories.length > 1 && (
          <Categories categories={props.categories} dark={props.dark} />
        )}
      </div>
      {props.articlesList && (
        <section className="bg-grey-100 py-12">
          <div className="container mx-auto px-6">
            <div className="columns-grid-3">
              {props.articlesList &&
                props.articlesList.map((list, i) => {
                  return (
                    <ArticlesList key={`article-list-${i}`} title={list.title} list={list.list} />
                  )
                })}
            </div>
          </div>
        </section>
      )}
      {props.banner && <Banner banner={props.banner} />}
    </>
  )
}

export default SupportPage
